import styled from 'styled-components';
import LinkButton from '../common/LinkButton';

const GalleryFooter = () => {
  return (
    <footer>
      <StyledP>
        감사합니다.
        <br />
        자세한 정보는 ‘예식 정보 보기' 버튼을 눌러주세요.
      </StyledP>
      <LinkButton url="/info">예식 정보 보기</LinkButton>
    </footer>
  );
};

const StyledP = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  padding: 3rem 0;
  text-align: center;
  margin-bottom: 7rem;
`;

export default GalleryFooter;
